import React, { useEffect, useState } from "react";
import {
  CogIcon,
  UserIcon,
  BuildingLibraryIcon,
} from "@heroicons/react/24/outline";
import DashboardHeader from "../Common/DashboardHeader";
import CustomerHeader from "../Common/CustomerHeader";
import CustomerInput from "../reusableComponents/CustomerInput";
import { Link } from "react-router-dom";
import logo from "../../img/BBPS_Horizontal.png";
import { DetailsApi } from "../../services/redux/ApiActions";
import { useDispatch, useSelector } from "react-redux";

export default function StepFourUpload() {
  const customerData = useSelector((state) => state.customerData.customerData);
  const [cin, setCIN] = useState("L17110MH1973PLC019786");
  const [showLogo, setShowLogo] = useState(false);
  const dispatch = useDispatch();
  const handleCIN = (e) => {
    setCIN(e.target.value);
  };
  const details = {
    result: {
      partners: [
        {
          email: "JohnDoe@gmail.com",
          partnerPAN: "ABCDE1234F",
          phone: "00001623",
          role: "checker & maker",
        },

        // Add more dummy data as needed
      ],
    },
  };
  const getDetails = async () => {
    // console.log(userAgent)
    const Payload = {
      id: customerData?.custId,
    };
    // console.log(Payload)
    const data = await dispatch(
      DetailsApi(Payload, customerData?.token_chr, "customer")
    );
    if (data?.result?.programId === 34 || data?.result?.programId === 35) {
      setShowLogo(false);
    } else {
      setShowLogo(true);
    }
  };

  useEffect(() => {
    getDetails();
  }, []);
  return (
    <>
      <body className="mailsentbody">
        <div className="logoBG">
          <div className="rightElement">
            <CustomerHeader />
            <div className="grid mt-6 grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
              <div className="col-span-12 md:col-span-8 lg:col-span-8 ">
                <div className="bg-white mx-2 shadow-xl p-6 mt-4 rounded-lg">
                  <div className="grid grid-cols-12 gap-4">
                    <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
                    <div className="col-span-12 md:col-span-8 lg:col-span-8">
                      <div className="py-2 text-center">
                        <h1 className="text-xl font-semibold letter-spacing">
                          LIST OF USERS
                        </h1>
                      </div>
                    </div>
                    <div className="col-span-12 md:col-span-2 lg:col-span-2">
                      {showLogo &&
                        {
                          /* <div
                          style={{
                            display: "flex",
                            justifyContent: "right",
                            marginTop: "-5px",
                          }}
                        >
                          <img src={logo} width={"100px"} height={"100px"} />
                        </div> */
                        }}
                    </div>
                  </div>
                  <div className="py-2 text-center">
                    <h1 className="text-sm text-gray-600">
                      Please create users for your organisation
                    </h1>
                  </div>
                  <div className=" border-none border-collapse rounded-md">
                    <div className="flex justify-between">
                      <div>
                        <input
                          type="checkbox"
                          id="checkboxOption2"
                          name="gstin"
                          className="form-checkbox h-5 w-5 text-indigo-600 border-2 border-gray-400 "
                        />
                        <label
                          htmlFor="checkboxOption2"
                          className="ml-2 text-black text-sm font-semibold"
                        >
                          Use complex approval matrix
                        </label>{" "}
                      </div>
                      <button className="border py-1 px-2">
                        <label className="hover:cursor-pointer">
                          Download Template
                        </label>
                      </button>
                    </div>

                    <div className=" bg-gray-300 p-6 mt-2 mb-2">
                      <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-12 sm:col-span-6 md:col-span-6 lg:col-span-4">
                          <div className="">
                            <label className="text-gray-700 font-bold text-sm">
                              Upload User List
                            </label>
                            <br />
                            <input
                              type="file"
                              className="mt-2"
                              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                            />
                          </div>
                        </div>
                        <div className="col-span-12 sm:col-span-6 lg:col-span-6">
                          <button className="vtpRm-action-button">
                            Upload File
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="overflow-x-auto border rounded-md shadow-sm mt-3">
                      <table className="min-w-full md:max-w-5xl lg:max-w-7xl xl:max-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-100">
                          <tr>
                            <th
                              scope="col"
                              className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2"
                            >
                              Sr.No
                            </th>
                            <th
                              scope="col"
                              className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2"
                            >
                              Email
                            </th>
                            <th
                              scope="col"
                              className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2"
                            >
                              Phone
                            </th>
                            <th
                              scope="col"
                              className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2"
                            >
                              Role
                            </th>
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                          {details?.result.partners.map((partner, index) => (
                            <tr key={index} className="border-t">
                              <td className="px-3 text-sm py-4 w-100 border-r">
                                {index + 1}
                              </td>
                              <td className="px-3 text-sm py-4 w-100 border-r">
                                {partner.email}
                              </td>
                              <td className="px-3 text-sm py-4 w-100 border-r">
                                {partner.phone}
                              </td>
                              <td className="px-3 text-sm py-4 w-100 border-r">
                                {partner.role}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="text-center">
                      <button className="vtpRm-action-button">
                        <Link to="/Customer/Step3CinDirectorList">Proceed</Link>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
            </div>
          </div>
        </div>
      </body>
    </>
  );
}
